import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initCollectionSearchFilters from '../sections/collection/initCollectionSearchFilters';
import initCustomSortBy from '../sections/collection/initCustomSortBy';
import initLoadMore from '../components/load-more';
import initCollectionDescription from '../components/collection-description';

const runCollectionInits = () => {
  [
    initCollectionSearchFilters,
    initCustomSortBy,
    initLoadMore,
    initCollectionDescription
  ].forEach(init => {
    try {
      init();
    } catch (err) {
      console.error('[collection template]', init.name, err);
    }
  });
};

ready(() => {
  runCollectionInits();
});

onShopifySectionLoad(() => {
  runCollectionInits();
});
